export const RecaptchaTokenHeaderKey = "Recaptcha-Token";